import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'

export default createUseStyles({
  button: {
    margin: '0 auto',
    width: '80%'
  },
  body: {
    padding: '10px 0'
  },
  icon: {
    '& path': {
      stroke: 'url(#success)'
    }
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  modalTextContainer: {
    color: WHITE,
    '& > div': {
      marginBottom: '10px',
      padding: '5px'
    },
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 0',
    padding: '10px 20px',
    textAlign: 'center'
  }
})

